import {Base, model, endpoint} from '@scoutgg/ftw/source/lib/model'

@model('Http')
@endpoint('', {root: '/api'})

export class Http extends Base {
}
